import { v4 as uuidv4 } from 'uuid';

export const cpfMask = value => {
    return value
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const cnpjMask = value => {
    return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1')
}

export const formatarDocumento = value => {
    if (!value) {
        return ''
    }
    const documentoLimpo = value.replace(/\D/g, '')

    if (documentoLimpo.length === 11) {
        const cpfFormatado = cpfMask(documentoLimpo)
        const cpfOculto = cpfFormatado.replace(/^\d{3}(?=\.)/, 'XXX').replace(/\d{2}$/, 'XX')
        return cpfOculto
    } else if (documentoLimpo.length === 14) {
        return cnpjMask(documentoLimpo)
    }

    return value
}

export const removeCpfMask = value => {
    return value.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4')
}

export const removeCnpjMask = value => {
    return value.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5')
}

export const removeHTMLMask = value => {
    return value ? value.toString().replace(/<\/?[^>]+(>|$)/g, '') : ''
}

export const cepMask = value => {
    return value
        ? value
              .toString()
              .replace(/\D/g, '')
              .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
        : ''
}

export const realMask = value => (value ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value) : '')

export const formatNumber = (amount, decimalCount = 2, decimal = ',', thousands = '.') => {
    try {

        if (isNaN(amount)) {
            return amount;
        }

        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
        let j = i.length > 3 ? i.length % 3 : 0

        return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : '')
        )
    } catch (e) {
        console.log(e)
    }
}

export const valorMask = valor => {
    valor = valor + ''
    valor = parseInt(valor.replace(/[\D]+/g, ''))
    valor = valor + ''
    valor = valor.replace(/([0-9]{2})$/g, ',$1')

    if (valor.length > 6) {
        valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2')
    }
    return valor
}

export const valorMask2 = valor => {
    return valor
        .toString()
        .toFixed(2) // casas decimais
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export const urlSecurityUtil =  textoPlan =>  {
    let uid1 = uuidv4().toUpperCase().substring(0, 5);
    let uid2 = uuidv4().toUpperCase().substring(0, 5);
    return new Buffer(uid1 + new Buffer(textoPlan+'').toString('base64') + uid2).toString('base64')
}

export const urlAnexos = (numero, origem) => {
    let base64data = new Buffer(new Date().toLocaleDateString('pt-BR', { timeZone: 'UTC' })).toString('base64')
    return '/documentos/svlet/download?numero=' + urlSecurityUtil(numero) + '&validacao=' + base64data + '&origem=' + urlSecurityUtil(origem)
}
